<template>
  <div class="change_inform">
    <div class="title">报价文件上传</div>
    <el-form :inline="true" :model="form2" class="form_table" ref="ruleForm1" :rules="rules" :inline-message="true">
      <el-form-item label="报价单"><el-button size="mini" type="primary" plain @click="fnDownloadQuotation">下载报价单</el-button></el-form-item>
      <el-form-item label="盖章报价文件" prop="QuotationFile">
        <el-upload
          :action="uploadUrl"
          :limit="1"
          :before-remove="removeConfirm"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :on-change="fileChange"
          :on-exceed="exceedFile"
          :on-success="handleSuccess"
          :on-error="handleError"
          :auto-upload="true"
          :file-list="form2.QuotationFile"
          :http-request="uploadQuotationFile"
          accept=".pdf"
          ref="uploader"
        >
          <el-button size="mini" type="primary" plain>点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <!-- <PdfViewer :asPartial="true" :height="PdfViewerHeight" :pdfUrl="pdfUrl"></PdfViewer> -->
    <div><iframe id="pdfPlayer" :src="'../../../js/pdfjs/web/viewer.html?file=' + pdfUrl" frameborder="0" width="100%" :height="PdfViewerHeight"></iframe></div>
    <div class="btn_wrap changeInform_btn_wrap">
      <span class="btn_1" @click="fnPreviewStep">返回上一步</span>
      <span class="btn_1" @click="fnSaveQuotation">提交报价单</span>
    </div>
  </div>
</template>

<script>
// import PdfViewer from '@/views/common/pdfViewer.vue';
export default {
  // components: { PdfViewer },
  props: {
    offerIds: { type: String, default: '' },
    businessType: { type: Number, default: 22 }
  },
  data() {
    return {
      PdfViewerHeight: '600px',
      uploadUrl: '',
      pdfUrl: '',
      form2: {
        QuotationFile: []
      },
      rules: {
        QuotationFile: [{ required: true, message: '请上传盖章报价单' }]
      }
    }
  },
  mounted() {
    let sysNo = window.localStorage.getItem('sysNo')
    var url = '/InQuiryPrice/PreviewQuotationFile?offerIds=' + this.offerIds + '&sysNo=' + sysNo
    this.pdfUrl = encodeURIComponent(url)
    // this.pdfUrl=this.baseURL + '/InQuiryPrice/PreviewQuotationFile?offerIds=' + this.offerIds + '&loginToken=' + encodeURIComponent(token);
  },
  methods: {
    fnDownloadQuotation() {
      let token = window.localStorage.getItem('loginToken')
      console.log(token)
      var url = '/InQuiryPrice/DownLoadQuotationFile?offerIds=' + this.offerIds + '&loginToken=' + encodeURIComponent(token)
      console.log(this.baseURL)
      this.downloadfile(this.baseURL + url)
    },
    fnPreviewStep() {
      this.$emit('update:currentStep', 0)
    },
    fnSaveQuotation() {
      if (this.form2.QuotationFile == null || this.form2.QuotationFile.length == 0) {
        this.$message.error('请上传报价文件')
        return
      }
      console.log(this.form2.QuotationFile)
      this.postRequest('/InQuiryPrice/CommitOffers', { offerIds: this.offerIds, fileId: this.form2.QuotationFile[0].fileId }).then((res) => {
        if (res.data.errcode == 0) {
          this.$message.success('操作成功')
          window.close()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传${this.uploadLimit}个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      if (file.hasOwnProperty('response')) {
        this.postRequest('/InQuiryPrice/DeleteQuotationFile', { fileId: file.response.fileId }).then((res) => {
          if (res.data.errcode == 0) {
            fileList.clear()
            this.form2.QuotationFile = null
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        // this.fileIds.push(response.fileId);
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    handleUpload(raw) {},
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf' || testmsg === 'PDF'
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension) {
        this.$message({
          message: '上传文件只能是pdf格式!',
          type: 'warning'
        })
      }
      return extension
    },
    uploadQuotationFile(params) {
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          console.log(res.data)
          this.form2.QuotationFile = res.data.FileList
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.changeInform_btn_wrap {
  width: 366px;
  margin: 10px auto 0;
  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}
.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;
    .el-input {
      width: 200px;
    }
  }
  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }
  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }
  .el-input {
    width: 300px;
    margin-right: 8px;
  }
  .businessTermEndDate {
    margin-bottom: 0 !important;
    .el-input {
      width: 100% !important;
    }
    .el-form-item__label:before {
      display: none;
    }
    .el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}
.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;
  .product_form {
    margin-bottom: 0;
  }
  .table_1 {
    width: 100%;
    margin: 0;
  }
  .table_1 tr td {
    border-right: none;
    border-bottom: none;
    text-align: center !important;
  }
}
.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}
.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;
    .el-range-input {
      font-size: 14px;
    }
  }
}
.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;
    .el-tree-node {
      display: inline-block;
    }
  }
}
.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}
.width_full {
  width: 100% !important;
}
</style>
